import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import config from 'config';
import Section from 'components/Section';
import { Divider, Paper } from '@material-ui/core';
import { Link } from 'react-router-dom';
import apiService from 'services/apiService';
import { useSelector } from 'react-redux';
import { translation } from 'utils/translate';

import './SiteInfo.css';

const SiteInfo = () => {
  const [version, setVersion] = useState(null);

  const lang = useSelector((store) => store.lang)

  // scroll to top when entering page view
  useEffect(() => window.scrollTo(0, 0), []);

  useEffect(() => {
    const fetchDoc = async () => {
      try {
        const result = await apiService.fetchData(
          'version',
        );
        setVersion(result?.version);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDoc();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {translation("siteinfo", "title", lang)} | {config.site.name}
        </title>
      </Helmet>
      <Section className="section--page">
        <Paper elevation={2}>
          <div className="page-wrapper">
            <h1 className="page-title">
              {translation("tietoja", lang)}
              <span className="page-title-version-number">
                v. {version}
              </span>
            </h1>
            <Divider />
            <p>
              {' '}
              Eduskunta hyväksyy joka vuosi satoja
              hallituksen esityksiä laiksi. Säädettyjen
              lakien taustalla on useita{' '}
              <a href="http://lainvalmistelu.finlex.fi/">
                valmisteluvaiheita
              </a>
              , joiden aikana tuotetaan valtava määrä
              asiakirjoja. Lakiehdotuksen taustaksi voidaan
              teettää raportteja, tutkimuksia tai
              selvityksiä. Lakitekstin ensimmäinen versio
              perusteluineen lähetetään
              lausuntokierrokselle. Eduskunnassa
              kansanedustajat keskustelevat
              lakiehdotuksista, ja nämä keskustelut
              dokumentoidaan täysistuntojen pöytäkirjoihin.
              Lainvalmistelun aikana syntyneet dokumentit
              ovat lähtökohtaisesti julkisia, ja niiden
              tulee olla kenen tahansa saatavilla. Aiemmin
              asiakirjat olivat hajallaan eri
              tietokannoissa, kaikki asiakirjat eivät olleet
              sähköisesti saatavilla, ja tietokantojen
              hakutoiminnot olivat hankalia käyttää.
              Asiakirjojen haku ja niiden käsittely
              tutkimustyössä vei todella paljon aikaa.
            </p>
            <p>
              Turun yliopiston oikeustieteellisen
              tiedekunnan tutkijat, opiskelijat ja
              yliopiston it-suunnittelijat kehittivät
              Lakitutka-verkkosovelluksen ratkaisuksi
              ongelmaan. Lakitutka kokoaa yhteen
              hakupalveluun lainvalmistelun aikana syntyvät
              julkiset asiakirjat koko valmisteluprosessin
              ajalta. Lakitutka tarjoaa samalla kaikille
              aiempaa paremman mahdollisuuden päästä käsiksi
              omaan arkeen vaikuttavan lainsäädännön
              tausta-aineistoon.
            </p>
            <p>
              Lakitutkalla voit tarkastella lakihankkeiden
              etenemistä hallituksen esitysten, annettujen
              lausuntojen, valiokunta-asiakirjojen ja
              eduskuntakeskusteluiden kautta. Lakitutkalla
              voi selvittää esimerkiksi eri hallitusten
              toimintaa tiettyyn teemaan liittyen.
              Lakitutkan avulla on mahdollista tutkia, mitkä
              tahot valmistelevat, puolustavat ja
              vastustavat itselle tärkeitä lakihankkeita.
              Yksittäisen lakihankkeen kulkua voi
              tarkastella aikajanalla, jolla näkyvät kaikki
              siihen liittyvät valmisteluasiakirjat.
              Aikajanan kautta on mahdollista avata
              asiakirjat luettavaksi yksi kerrallaan.
              Lakitutkassa on visualisointiominaisuus, joka
              esittää hakutulokset nopeasti hahmotettavina
              diagrammeina.
            </p>
            <p>
              Lakitutka helpottaa myös tutkimuksen
              tekemistä. Lakitutkasta on mahdollista ladata
              itse rajattu joukko asiakirjatiedostoja, kuten
              hallituksen esityksiä tai lausuntokierrosten
              lausuntoja. Lakitutkasta voi ladata myös
              matriiseja asiakirjojen metatiedoista, eikä
              asiakirjojen tunnistetietoja tarvitse enää
              kirjata käsityönä.
            </p>
            <p>
              Lakitutkan tavoitteena on lisätä kiinnostusta
              lakien syntymekanismeihin ja tuoda lakien
              säätämiseen liittyvää tietoa yhä useamman
              saataville. Tarkoituksena on edistää
              lainsäädännön läpinäkyvyyttä, tuoda ilmi
              lainsäädäntöprosesseihin liittyvää
              vaikuttamista, tukea aktiivista
              kansalaisyhteiskuntaa ja parantaa jokaisen
              osallistumismahdollisuuksia, sekä helpottaa
              lainsäädäntöön liittyvän tutkimuksen
              tekemistä.
            </p>
            <p>
              Tutustu Lakitutkan ohjevideoihin{' '}
              <Link to="/ohjeet">täältä</Link>.
            </p>{' '}
            <h2 className="page-subtitle">
              Käytetyt rajapinnat ja aineistoon liittyvät
              varaumat
            </h2>
            <p>
              Lakitutkan asiakirjamateriaalit haetaan{' '}
              <a
                href="https://valtioneuvosto.fi/hankkeet"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                valtioneuvoston Hankeikkunasta
              </a>{' '}
              ja{' '}
              <a
                href="https://avoindata.eduskunta.fi/"
                target="_BLANK"
                rel="noopener noreferrer"
              >
                Eduskunnan avoimen datan verkkopalvelusta.
              </a>{' '}
              Asiakirjojen saatavuus tietyistä vuosista
              alkaen liittyy siihen, mistä alkaen
              asiakirjoja on saatavilla avoimista
              rajapinnoista. Hallituksen esityksiä on
              kerätty hieman pidemmältä ajalta.
            </p>
            <p>
              Lainsäädäntöhankkeen tiedot ja hankkeisiin
              liittyvät asiakirjat, kuten lausuntokierrosten
              lausunnot, ovat saatavilla vuodesta 1995
              alkaen. Hankkeet ja niihin liittyvät
              asiakirjat löytyvät ainoastaan osittain.
              Varsinkin vuosilta 1995-2000 puuttuu
              asiakirjoja, sillä niitä ei ole julkaistu
              sähköisessä muodossa. Samasta syystä
              asiakirjoja puuttuu myös myöhemmistä
              hankkeista. Jatkossa näitä on tarkoitus lisätä
              tietokantaan. Tiedot on haettu valtioneuvoston
              Hankeikkunasta.
            </p>
            <p>
              Hallituksen esitykset ovat saatavilla vuodesta
              1991 alkaen. Uusia hallituksen esityksiä ja
              niihin liittyviä dokumentteja päivitetään
              Lakitutkaan. Myös vanhempaa tietoa pyritään
              tulevaisuudessa lisäämään palveluun. Lähteenä
              Eduskunnan avoimen datan verkkopalvelu.
            </p>
            <p>
              Valiokunta-asiakirjat eli valiokuntien
              lausunnot ja mietinnöt ovat saatavilla
              vuodesta 1991 alkaen. Tämän välilehden alta
              löytyvät myös valiokuntien
              asiantuntijalausunnot, jotka ovat saatavilla
              vuodesta 2015 alkaen. Lähteenä Eduskunnan
              avoimen datan verkkopalvelu.
            </p>
            <p>
              Eduskuntakeskustelujen pöytäkirjat ovat
              saatavilla vuodesta 2015 alkaen. Lakitutkassa
              on tällä hetkellä pöytäkirjat vain niistä
              keskusteluista, jotka liittyvät johonkin
              valmisteltavaan lakiin. Lähteenä Eduskunnan
              avoimen datan verkkopalvelu.
            </p>
            <h2 className="page-subtitle">Työryhmä</h2>
            <ul>
              <li>
                <a href="https://www.utu.fi/fi/ihmiset/anne-alvesalo-kuusi"
                target="_BLANK"
                rel="noopener noreferrer">Anne Alvesalo-Kuusi</a>
              </li>
              <li>
                <a href="https://www.utu.fi/fi/ihmiset/ossi-laine"
                target="_BLANK"
                rel="noopener noreferrer">Ossi Laine</a>
              </li>
              <li>
                <a href="https://www.utu.fi/fi/ihmiset/istvan-rytkonen"
                target="_BLANK"
                rel="noopener noreferrer">István Rytkönen</a>
              </li>
              <li>
                <a href="https://www.utu.fi/fi/ihmiset/marjaana-sjolund"
                target="_BLANK"
                rel="noopener noreferrer">Marjaana Sjölund</a>
              </li>
              <li>
                <a href="https://www.utu.fi/fi/ihmiset/emma-holkeri"
                target="_BLANK"
                rel="noopener noreferrer">Emma Holkeri</a>
              </li>
            </ul>
            <p>
              Yhteydenotot osoitteeseen{' '}
              <a href="mailto:lakitutka@utu.fi">lakitutka@utu.fi</a>{' '}
              tai suoraan työryhmän jäseniin.
            </p>
            <h2 className="page-subtitle">
              Lakitutkan rahoittajat
            </h2>
            <p>
              Lakitutka on kehitetty {' '}<a href="https://www.utu.fi/"
                target="_BLANK"
                rel="noopener noreferrer">Turun yliopistossa</a>. 
            </p>
            <p>
              Lakitutkaa kehitetään edelleen{' '}
              <a href="https://www.hiljaisettoimijat.fi/"
                target="_BLANK"
                rel="noopener noreferrer">SILE-hankkeen</a>{' '}
              yhteydessä erityisesti lainvalmistelun saavutettavuuteen keskittyen sekä {' '}
              <a href="https://lawpol.fi/"
                target="_BLANK"
                rel="noopener noreferrer">LAWPOL-hankkeessa</a>{' '}
              laajentaen palvelussa saatavilla olevaa asiakirja-aineistoa.
            </p>
            <h3 className="page-subtitle">
              SILE-hanke
            </h3>
            <img
              alt="SILE - Hiljaiset toimijat ja laki"
              src="/sile.png"
              className='funded-by'
            />
            <p>
              SILE-hanketta rahoittaa Suomen Akatemian yhteydessä toimiva 
              strategisen tutkimuksen neuvosto.
              Päätösnumerot 335442 ja 335654 (2020-2023) sekä 358263 ja 358264 (2023-2026)
            </p>
            <p>
              <a href="https://www.hiljaisettoimijat.fi/"
                target="_BLANK"
                rel="noopener noreferrer">SILE-hankkeen verkkosivut</a>
            </p>
            <h3 className="page-subtitle">
              LAWPOL-hanke
            </h3>
            <img
              alt="Euroopan unionin rahoittama NextGenerationEU"
              src="/FI_Euroopan_unionin_rahoittama.png"
              className='funded-by'
            />
            <p>
              LAWPOL-konsortio on saanut Suomen Akatemialta FIRI2022: 
              Paikalliset tutkimusinfrastruktuurit -rahoituksen vuosille 2023-2025 
              päätösnumeroilla 352827, 353569 ja 352828. 
              Rahoitus on osa EU:n elpymisvälinerahoitusta.
            </p>
            <p>
              <a href="https://lawpol.fi/"
                target="_BLANK"
                rel="noopener noreferrer">LAWPOL-hankkeen verkkosivut</a>
            </p>
          </div>
        </Paper>
      </Section>
    </>
  );
};

export default SiteInfo;
